import { Button, notification, Pagination, Row, Table } from "antd";
import moment from "moment";
import React, { ReactElement, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  EditableList,
} from "../../../compnents/list/EditableList";
import { NavBar } from "../../../compnents/nav/NavBar";
import { DateTimeFormatSimple } from "../../../models/datetime";
import { RecardDrugParams } from "../../../services/recardDrug";
import { ThemeContext } from "../../../theme/ThemeContext";
import { AGColumns, RecardDrugColumns } from "./columns";
import { RecardDrugQuery } from "./Query";
import { getRecardDrugList, selectCurrent, selectRecardDrugList, selectTotal, setCurrent, getRecardDrugListExoprt, selectPageLoading, setPageLoading } from "./recardDrugSlice";
import styles from "./recardDurg.module.css";
import { PrintOutlined } from "../../../compnents/icons/Icons";
import { sleectUserData } from "../../putstorelist/putstorelistSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { RootDispatch } from "../../../app/store";
import { getRecentTimePrint } from "../../recentTime/recentTimeSlice";
import { getPrinters, initializePrintService, printTemplate, selectPrintServiceState, selectTemplateOffsets } from "../../print/printSlice";
import { getSortColumnList, LoadingState } from "../../../models/common";
import {setSelectId} from "../../wms/supplierSlice";
import {useHistory} from "react-router-dom";
import {traceRoute} from "../../../layouts/layoutSlice";
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from "../../transactionQuery/transactionQuerySlice";
import SimpleAgGrid from "../../../compnents/simpleTable/SimpleAgGrid";

export const RecardDrug = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>(); 
  const [queries, setQueries] = useState<RecardDrugParams>({
    recepitsDateStart: moment().startOf("day").format(DateTimeFormatSimple),
    recepitsDateEnd: moment().endOf("day").format(DateTimeFormatSimple),
  });

  const [exportLoading, setExportLoading] = useState(false)

  const Current = useSelector(selectCurrent);

  const total = useSelector(selectTotal);

  const data = useSelector(selectRecardDrugList);

  const history = useHistory()

  const [size, setSize] = useState(10);

  const theme = useContext(ThemeContext);

  const tableRef = useRef(null);

  const [cell, setCell] = useState<any>({})   //合计栏

  const [printLoading, setPrintLoading] = useState(false)

  const offsets = useSelector(selectTemplateOffsets)

  const initialized = useSelector(selectPrintServiceState)   //初始化打印

  const pageLoadingRX = useSelector(selectPageLoading);

  // 所有的列表
  const listData: any = [
      {
        headerName: '序号',
        width: 60,
        minWidth: 60,
        field: 'index',
        pinned: 'left',
        lockPosition: "left",
        suppressMovable: true,
        visible: true,
      },
       {
        headerName: '业务单号',
        field: 'putNumber',
        width: 140,
        minWidth: 140,
        pinned: 'left',
        lockPosition: "left",
        suppressMovable: true,
        visible: true,
      },
       {
        headerName: '商品编码',
        field: 'no',
        width: 130,
        minWidth: 130,
        pinned: 'left',
        lockPosition: "left",
        suppressMovable: true,
        visible: true,
      },
      {
        headerName: '产品信息',
        field: 'producInfo',
        width: 300,
        minWidth: 300,
        pinned: 'left',
        lockPosition: "left",
        suppressMovable: true,
        visible: true,
      },
      {
        headerName: '制剂规格',
        field: 'spec',
        minWidth: 160,
        visible: true,
      },
      {
        headerName: '剂型',
        field: 'doseCategory',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '通用名',
        field: 'genericName',
        minWidth: 120,
        visible: true,
      },
      {
        headerName: '产地',
        field: 'origin',
        minWidth: 110,
        visible: true,
      },
       {
        headerName: '医保国码',
        field: 'hilistCode',
        minWidth: 210,
        visible: true,
      },
      {
        headerName: '批次号',
        field: 'batchNo',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '批准文号',
        field: 'approvalNumber',
        minWidth: 150,
        visible: true,
      },
      {
        headerName: '库房名称',
        field: 'storehouseName',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '生产日期',
        field: 'productDate',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '有效期至',
        field: 'deadline',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '进价',
        field: 'unitPrice',
        minWidth: 100,
        visible: true,
      },
      {
        headerName: '销售价',
        field: 'retailPrice',
        align: 'center',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '采购数量',
        field: 'count',
        minWidth: 120,
        visible: true,
      },
      {
        headerName: '变动金额(进价)',
        field: 'changeUnitPrice',
        minWidth: 130,
        visible: true,
      },
      {
        headerName: '供应商',
        field: 'supplierName',
        minWidth: 140,
        visible: true,
      },
      {
        headerName: '采购时间',
        field: 'recepitsDate',
        minWidth: 110,
        visible: true,
      },
      {
        headerName: '采购人员',
        field: 'userName',
        minWidth: 110,
        visible: true,
      },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allColumnData = listData

  // 默认要展示的列的值
  const selectColumns = allColumnData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'recardDrug',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'recardDrug',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const sameFileds = allColumnData?.find((item: any) => item?.field == v?.field)
        const resetData = data?.map((v: any) => ({
          ...v,
          minWidth: sameFileds?.minWidth || v?.minWidth,
          width: sameFileds?.width || v?.width,
          headerName: sameFileds?.headerName || v?.headerName,
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allColumnData)
        // 筛选后存在后端的数据

        setFilterColumnList(filterList?.length ? filterList : allColumnData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allColumnData)
        setFilterColumnList(allColumnData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        dispatch(setPageLoading(false))
      })
  }

  useEffect(() => {
    if (initialized === LoadingState.Idle) {
      dispatch(initializePrintService())
        .then(unwrapResult)
        .catch(() => {
          // do nothing.
        })
    }
    if (initialized === LoadingState.Finished) {
      dispatch(getPrinters())
    }

  }, [dispatch, initialized])


  useEffect(() => {
    if (queries?.timeHead) {
      dispatch(setPageLoading(true))
      dispatch(getRecardDrugList({
        ...queries, current: Current, size, timeTail: undefined,
        timeHead: undefined,
        recepitsDateStart: moment(queries.timeHead).format(
          DateTimeFormatSimple
        ),
        recepitsDateEnd: moment(queries.timeTail).format(
          DateTimeFormatSimple
        ),
      }))
      getPageColumnList()
      sessionStorage.setItem('/recardDrug-queries',JSON.stringify(queries))
      setTimeout(() => {
        dispatch(setPageLoading(false))
      }, 3000)
    }

  }, [queries, size, Current,]);

  useEffect(() => {
    if (data.length == 0) {
        setCell({});
        return
    }
    const tempArr = data.filter((item: any) => {
      return item.totalUnitPrice != -1
    })
    setCell(tempArr[0])
  }, [data])

  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(getRecardDrugListExoprt({
      ...queries, current: Current, size, timeTail: undefined,
      timeHead: undefined,
      recepitsDateStart: moment(queries.timeHead).format(
        DateTimeFormatSimple
      ),
      recepitsDateEnd: moment(queries.timeTail).format(
        DateTimeFormatSimple
      ),
    }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res;
        const blob = new Blob([content]);
        const fileName = '药品购进记录.xlsx';
        const selfURL = window[window.webkitURL ? "webkitURL" : "URL"];
        const elink = document.createElement("a");
        if ("download" in elink) {
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = selfURL["createObjectURL"](blob);
          document.body.appendChild(elink);
          // 触发链接
          elink.click();
          selfURL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          return (navigator as any).msSaveBlob(blob, fileName);
        }
      })
      .then(() => {
        notification.success({
          message: "导出成功",
          duration: 3,
        });
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <NavBar
        style={{ margin: '10px 20px 0px 20px' }}
        where={['库存', '药品购进记录']}
        backtrace={{
          name: '库房工作站',
          path: '/storage/station',
          state: { station: '3' },
        }}
        buttons={
          // <ReactToPrint
          //   trigger={() => (
          //     <Button
          //     style={{border:"none",background:"#FFFFFF",display: "flex",
          //     alignItems:"center"}}
          //       size="small"
          //       loading={printLoading}
          //       onClick={() => {
          //         // setPrintLoading(true)
          //         // dispatch(getRecentTimePrint({ templateCode: 'RecordOfDrugPurchase' }))
          //         //   .then(unwrapResult)
          //         //   // .then(() => notification.success({ message: '打印成功' }))
          //         //   .finally(() => setPrintLoading(false))
          //       }}
          //     >
          //        <PrintOutlined style={{fill:"#666",width:"18px",height:"18px",marginRight:"8px"}}/>
          //       打印
          //     </Button>
          //   )}
          //   content={() => tableRef.current}
          // />

          <Button
            style={{
              border: 'none',
              background: '#FFFFFF',
              display: 'flex',
              alignItems: 'center',
            }}
            size='small'
            loading={printLoading}
            onClick={async () => {
              await dispatch(
                printTemplate({
                  addInvRecItemBuyList: {
                    ...queries,
                  },
                  leftOffset: 0,
                  topOffset: 0,
                  templateCode: 'RecordOfDrugPurchase',
                })
              )
            }}
          >
            <PrintOutlined
              style={{
                fill: '#666',
                width: '18px',
                height: '18px',
                marginRight: '8px',
              }}
            />
            打印
          </Button>
        }
      />
      <div className={styles.content}>
        <RecardDrugQuery
          exportloading={exportLoading}
          loading={pageLoadingRX}
          filterColumn={allColumnList} //筛选列
          filterSelectList={filterSelectList}
          // 筛选列变化时的数据
          submitPageList={(v: any) => {
            dispatch(setPageLoading(true))
            submitPageList(v)
            setAllColumnList(v)
          }}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v })
            dispatch(setCurrent(1))
          }}
          outClued={() => outCluedExport()}
          continueOrder={(v:any, type: string) => {
            if(type === 'jzcx') {
              setQueries({ ...queries, ...v, isAccurate: Number(v) })
            }
            dispatch(setCurrent(1))
          }}
        />
        <div ref={tableRef} style={{ height: 'calc(100% - 40px)' }}>
          {/* <EditableList
            style={{ height: '100%', overflowY: 'auto' }}
            loading={pageLoadingRX}
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row className={styles.total}>
                  <Table.Summary.Cell index={0}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1}></Table.Summary.Cell>
                  <Table.Summary.Cell index={1}></Table.Summary.Cell>
                  <Table.Summary.Cell className={styles.footingTitle} index={2}>
                    合计
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3}></Table.Summary.Cell>
                  <Table.Summary.Cell index={4}></Table.Summary.Cell>
                  <Table.Summary.Cell index={13}></Table.Summary.Cell>
                  <Table.Summary.Cell index={14}></Table.Summary.Cell>
                  <Table.Summary.Cell index={5}></Table.Summary.Cell>
                  <Table.Summary.Cell index={6}></Table.Summary.Cell>
                  <Table.Summary.Cell index={14}></Table.Summary.Cell>
                  <Table.Summary.Cell index={15}></Table.Summary.Cell>
                  <Table.Summary.Cell index={16}></Table.Summary.Cell>
                  <Table.Summary.Cell index={17}></Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={7}>
                    {cell?.totalUnitPrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={8}>
                    {cell?.totalRetailPrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='center' index={9}>
                    {cell?.totalCount || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell align='right' index={10}>
                    {cell?.totalChangePrice || '-'}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={11}></Table.Summary.Cell>
                  <Table.Summary.Cell index={12}></Table.Summary.Cell>
                  <Table.Summary.Cell index={13}></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            )}
            className={styles.recardDrug}
            bordered
            rowKey={(_, i) =>
              queries
                ? (queries.size || 0) * (queries.current || 0) + (i || 0)
                : 0
            }
            onChangePage={(current, pageSize) => {
              setSize(pageSize as number)
              dispatch(setCurrent(current))
            }}
            page={{
              items: data,
              current: Current,
              size: size,
              total: total,
            }}
            columns={RecardDrugColumns(size * (Current - 1),(id:number) => {
              history.push({
                pathname: "/putlist",
                state: { category: '1', selectId: id , source : 1 },
              });
            })}
          /> */}
          <SimpleAgGrid
            rowHeight={56}
            page={{
              items: data,
              current: Current,
              size: size,
              total: total,
            }}
            column={(AGColumns(
              size * (Current - 1),
              (id: number) => {
                history.push({
                  pathname: "/putlist",
                  state: { category: '1', selectId: id, source: 1 },
                })
              },
              allColumnList,cell
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoadingRX}
            pagination={true}
            pageKey={'recardDrug'}
            rowSelection="multiple"
            pinnedBottomRowData={[{
              unitPrice: cell?.totalUnitPrice || '-',
              retailPrice: cell?.totalRetailPrice || '-',
              count: cell?.totalCount || '-',
              changeUnitPrice: cell?.totalChangePrice || '-',
              // 剩余没有合计行的列展示为空
            }]}
            suppressRowClickSelection={true}
            // 配置底部行样式
            getRowStyle={(params) => {
              if (params.node.rowPinned) {
                return {
                  fontWeight: 'normal',
                  backgroundColor: '#D9F2FF',
                };
              }
              return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
            }}
            onChangePage={(current, size) => {
              setSize(size as number)
              dispatch(setCurrent(current))
            }}
            onColumnResized={(v) => {
              return
            }}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
          />
        </div>
      </div>
    </div>
  )
};
